import { isString } from './util';
import { eventProperties } from './events';
import { UAParser } from 'ua-parser-js';

const getPerformancePaintEntries = (name) => {
  if (window.performance && window.performance.getEntriesByType) {
    return window.performance
      .getEntriesByType('paint')
      .filter((entry) => entry.name === name);
  }
  return [];
};

const updateLCP = (entry, sendLoadMetrics, eventForLCP) => {
  if (entry.startTime < eventProperties.firstHiddenTime) {
    eventProperties.LCP = Math.round(entry.startTime);
    if (sendLoadMetrics) {
      const scrollHeight = document.documentElement.scrollHeight || 0;
      const pageHeight = document.documentElement.clientHeight || 0;
      if (pageHeight >= scrollHeight) {
        eventForLCP();
      }
    }
  }
};

const addVisibilityChangeListener = (po, sendLoadMetrics, eventForLCP) => {
  document.addEventListener(
    'visibilitychange',
    function handleVisibilityChange() {
      if (document.visibilityState === 'hidden') {
        document.removeEventListener(
          'visibilitychange',
          handleVisibilityChange,
          true
        );
        const records = po.takeRecords ? po.takeRecords() : [];
        records.forEach((entry) =>
          updateLCP(entry, sendLoadMetrics, eventForLCP)
        );
        po.disconnect();
      }
    },
    true
  );
};

export const isBrowserSafari17 = () => {
  const parser = new UAParser();
  const browser = parser.getBrowser();
  return (
    /safari/i.test(browser.name ?? '') && /^17\./.test(browser.version ?? '')
  );
};

export const firstContentfulPaintTime = () => {
  if (eventProperties.firstHiddenTime === 0) {
    return null;
  }

  const entries = getPerformancePaintEntries('first-contentful-paint');
  if (entries.length > 0) {
    const FCP = Math.round(entries[0].startTime);
    return FCP < eventProperties.firstHiddenTime ? FCP : null;
  }

  if ('chrome' in window && window.chrome.loadTimes) {
    const a = window.chrome.loadTimes();
    if (
      a.requestTime &&
      a.firstPaintTime &&
      window.performance &&
      window.performance.timing
    ) {
      const FCP = Math.round(
        1e3 * a.firstPaintTime - window.performance.timing.navigationStart
      );
      return FCP < eventProperties.firstHiddenTime ? FCP : null;
    }
  }

  return null;
};

export const largestContentfulPaintTime = (
  sendLoadMetrics,
  eventForLCP = () => {}
) => {
  try {
    const po = new PerformanceObserver((entryList) => {
      const entries = entryList.getEntries();
      entries.forEach((entry) => {
        updateLCP(entry, sendLoadMetrics, eventForLCP);
      });
    });
    po.observe({ type: 'largest-contentful-paint', buffered: true });

    addVisibilityChangeListener(po, sendLoadMetrics, eventForLCP);
  } catch (e) {
    // do nothing
  }
};

export const netType = () => {
  return navigator.connection?.type ?? '';
};

export const getLanguage = () => {
  const language = (navigator.language || '').toLowerCase();
  return isString(language) ? language : '';
};

export const getJavaEnabled = () => {
  try {
    return navigator.javaEnabled();
  } catch (a) {
    return false;
  }
};

export const getNotificationPermission = () => {
  return 'Notification' in window && Notification.permission === 'granted'
    ? 1
    : 0;
};

export const isIframe = () => {
  try {
    return window.top !== window.self;
  } catch (error) {
    return false;
  }
};

export const getCookiesEnabled = () => {
  if (navigator.cookieEnabled) return true;
  document.cookie = 'cookietest=1';
  const ret = document.cookie.includes('cookietest=');
  document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
  return ret;
};

export const adBlockExists = (config) => {
  if (config.adBlockExists !== undefined) {
    return config.adBlockExists;
  }

  const fakeAd = document.createElement('div');
  fakeAd.className =
    'textads banner-ads banner_ads ad-unit ad-zone ad-space adsbox';
  fakeAd.style.height = '1px';
  document.body.appendChild(fakeAd);

  config.adBlockExists = fakeAd.offsetHeight === 0;

  fakeAd.remove();
  return config.adBlockExists;
};
